export default {
  RELATION: "relation",
  POLICY: "policy",
  DAMAGE: "damage",
};
